var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-input-number el-input-number--mini is-controls-right" },
    [
      _c(
        "span",
        {
          staticClass: "el-input-number__decrease",
          on: { click: _vm.onDecrease }
        },
        [_c("i", { staticClass: "el-icon-arrow-down" })]
      ),
      _c(
        "span",
        {
          staticClass: "el-input-number__increase",
          on: { click: _vm.onIncrease }
        },
        [_c("i", { staticClass: "el-icon-arrow-up" })]
      ),
      _c("el-input", {
        attrs: { value: _vm.formatValue, type: "number" },
        on: { focus: _vm.onFocus, input: _vm.onInput, blur: _vm.onBlur }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }